import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { RemoveRedEye } from '@mui/icons-material';
import { Button, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import TableView from 'app/shared/Tableview/Tableview';
import React, { useCallback, useEffect, useState } from 'react';
function AllTransaction() {
   const [trType,setTrType] = useState([])
   const [Data,setData] = useState([])
   const [currentType, setCurrentType] = useState(null);
   const [selectedtrType,setSelectedTrType] = useState(null)
   const swal = useSwalWrapper()
   const fetchtrtypedata = useCallback(()=>{
    jwtAuthAxios.get('transation/allTrtype').then((res)=>{
      setTrType(res.data.data);
      setCurrentType('DETAIL')
    })
   })
   const fetchtrdata = useCallback(()=>{
    jwtAuthAxios.get('transation?trtyid='+selectedtrType).then((res)=>{
      setData(res.data.data);
    }).catch(()=>{
      swal.fire({
        icon:'error',
        text:'something Went Wrong',
      }) 
    })
   },[selectedtrType])
useEffect(()=>{
  fetchtrtypedata()
},[])
const handleDetailView = async (e) => { 
  // console.log(e);
  setData([])
  await jwtAuthAxios.post('transation/transactionDetails',{P_NO:e.FL_TRANS_NO,P_TYPE:e.TYPEID}).then(res=>{
    // console.log(res.data.data);//
    setData(res)
    setCurrentType('DETAIL')
  }).catch(()=>{
    alert('internal server error')
    setCurrentType('INWARD')
  })
  // let Data = await getTransactionDetail(`pid=${e.ID}`)
  // setData(Data)
}

useEffect(()=>{
  selectedtrType && fetchtrdata()
},[selectedtrType])
  return (
    <div>
    <Grid container>
    <Grid item xs={6}>
      <h2>My Transaction</h2>
    </Grid>
    <Grid item xs={6}>
    <FormControl sx={{mb:2,display: 'block',marginLeft: 'auto',width: 'fit-content'}}>
      <InputLabel>Select Transaction Type</InputLabel>
      <Select sx={{width:200}} value={selectedtrType} label={"Select Transaction Type"} onChange={e =>setSelectedTrType(e.target.value)}>
        {trType.map((trType) => (
          <MenuItem  key={trType.ID} value={trType.ID}>
            {trType.VALUE}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    </Grid>
    </Grid>
    {(Array.isArray(Data)) && <TableView body={Data} actions={currentType == 'INWARD' ? (row) => (
          <div>
            <Button onClick={() => handleDetailView(row)}><RemoveRedEye /></Button>
            {/* <button >Edit</button>
          <button onClick={() => handleDelete(row)}>Delete</button> */}
          </div>
        ) : (row) => (
          <div>
            {/* <Button onClick={() => handleEdit(row)}><Edit /></Button> */}
            {/* <button >Edit</button>
          <button onClick={() => handleDelete(row)}>Delete</button> */}
          </div>
        )} />}
  </div>
  );
}
AllTransaction.Modulename = 'allTransaction'

export default AllTransaction